// src/pages/FormPage/useFormLoader.js
import { useEffect, useState } from 'react';
import { fetchFromGitHub } from './services/fetchFromGitHub';

/**
 * Hook para carregar todos os arquivos remotos de um formulário baseado em formid/account/project
 * @param {object} params
 * @param {string} params.account
 * @param {string} params.project
 * @param {string} params.formid
 * @returns {object}
 */
export function useFormLoader({ account, project, formid }) {
  const [formSchema, setFormSchema] = useState(undefined); // undefined = ainda carregando
  const [uiSchema, setUiSchema] = useState(undefined);
  const [formData, setFormData] = useState(undefined);
  const [config, setConfig] = useState(undefined);
  const [customStyle, setCustomStyle] = useState(undefined);
  const [functions, setFunctions] = useState(undefined);
  const [spaLayout, setSpaLayout] = useState(undefined);
  const [schemaTY, setSchemaTY] = useState(undefined);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!account || !project || !formid) return;

    let isMounted = true;

    const loadAll = async () => {
      try {
        await Promise.all([
          fetchFromGitHub(account, project, formid, 'formschema.json', value => isMounted && setFormSchema(value ?? null)),
          fetchFromGitHub(account, project, formid, 'formuischema.json', value => isMounted && setUiSchema(value ?? null)),
          fetchFromGitHub(account, project, formid, 'formdata.json', value => isMounted && setFormData(value ?? null)),
          fetchFromGitHub(account, project, formid, 'formconfig.json', value => isMounted && setConfig(value ?? null)),
          fetchFromGitHub(account, project, formid, 'formstyle.css', value => isMounted && setCustomStyle(value ?? null)),
          fetchFromGitHub(account, project, formid, 'formfunctions.js', value => isMounted && setFunctions(value ?? null)),
          fetchFromGitHub(account, project, formid, 'formspalayout.js', value => isMounted && setSpaLayout(value ?? null)),
          fetchFromGitHub(account, project, formid, 'formschematy.json', value => isMounted && setSchemaTY(value ?? null))
        ]);
      } catch (err) {
        console.error('Erro ao carregar dados do formulário:', err);
        isMounted && setFormSchema(null); // força o NotFound
      } finally {
        isMounted && setIsLoading(false);
      }
    };

    loadAll();

    return () => {
      isMounted = false;
    };
  }, [account, project, formid]);

  return {
    formSchema,
    uiSchema,
    formData,
    config,
    customStyle,
    functions,
    spaLayout,
    schemaTY,
    isLoading,
  };
}
